import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ScoopHero from "./sections/ScoopHero";
import Gallery from "./sections/Gallery";
import Philosophy from "./sections/Philosophy";
import Favorites from "./sections/Favorites";
import Scoops from "./sections/Scoops";
import Newsletter from "./sections/Newsletter";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ScoopHero />
      <Gallery />
      <Philosophy />
      <Favorites />
      <Scoops />
      <Newsletter />
      <Footer />
    </div>;
}